import { z } from 'zod';
import { PlanSchema, SubscriptionStatusSchema, TokenScopeSchema, WebhookEventSchema } from './enums.js';

export const BillingInfoSchema = z.object({
  orgId: z.string(),
  plan: PlanSchema,
  subscriptionStatus: SubscriptionStatusSchema,
  seats: z.number().int(),
  memberCount: z.number().int(),
  currentPeriodEnd: z.string().nullable(),
  stripeConfigured: z.boolean(),
});
export type BillingInfo = z.infer<typeof BillingInfoSchema>;

export const ApiTokenSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  name: z.string(),
  scopes: z.array(TokenScopeSchema),
  createdBy: z.string(),
  createdAt: z.string(),
  lastUsedAt: z.string().nullable(),
  revokedAt: z.string().nullable(),
});
export type ApiToken = z.infer<typeof ApiTokenSchema>;

export const CreateTokenInputSchema = z.object({
  name: z.string().min(1).max(200),
  scopes: z.array(TokenScopeSchema).min(1),
});
export type CreateTokenInput = z.infer<typeof CreateTokenInputSchema>;

/** Returned once at creation time with the plaintext token. */
export const CreatedTokenSchema = ApiTokenSchema.extend({
  token: z.string(),
});
export type CreatedToken = z.infer<typeof CreatedTokenSchema>;

export const WebhookEndpointSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  url: z.string(),
  events: z.array(WebhookEventSchema),
  active: z.boolean(),
  createdBy: z.string(),
  createdAt: z.string(),
});
export type WebhookEndpoint = z.infer<typeof WebhookEndpointSchema>;

export const CreateWebhookInputSchema = z.object({
  url: z.string().url(),
  events: z.array(WebhookEventSchema).min(1),
});
export type CreateWebhookInput = z.infer<typeof CreateWebhookInputSchema>;

/** Returned once at creation time with the signing secret. */
export const CreatedWebhookSchema = WebhookEndpointSchema.extend({
  secret: z.string(),
});
export type CreatedWebhook = z.infer<typeof CreatedWebhookSchema>;
